export default {
  'customReporting.runReport': 'Run Report',
  'customReporting.modifyCriteria': 'Modify Criteria',
  'customReporting.reportCriteria': 'Report Criteria',
  'customReporting.include': 'Include',
  'customReporting.maskAccountNumbers': 'Unmask account numbers in report output',
  'customReporting.statusBalances': 'Status Balances',
  'customReporting.transactionTotals': 'Daily Transaction Totals',
  'customReporting.transactions': 'Transactions',
  'customReporting.datePeriod': 'Period',
  'customReporting.transactionType': 'Transaction Type',
  'customReporting.expandAllAccounts': 'Expand all accounts',
  'customReporting.expandAccount': 'Expand account',
  'customReporting.maxAccounts':
    '<%= max %> or fewer accounts recommended for same day reporting.',
  'customReporting.maxAccountsExceeded':
    'Selecting <%= max %>+ accounts may result in slower processing for same day reporting.',
  'customReporting.firstDay': 'First Day',
  'customReporting.lastDay': 'Last Day',
  'customReporting.modalHeader': 'Processing report',
  'customReporting.modalCancelButton': 'Cancel report',
  'customReporting.exportModalHeader':
    '<%= optionsAvailable ?  "Some" : "The selected" %> data options are not supported for export.',
  'customReporting.exportModalMessageNotSupported':
    '<%= options %> are not supported for <% if(sameDay){ %>same day <% } %><%= format %>.',
  'customReporting.exportModalMessageOptionsWillExport':
    'Only <%= options %> will be included in the export.',
  'customReporting.exportModalMessageOptionsModifyCriteria':
    'Modify the report criteria to include <%= options %> only.',
  'customReporting.modalText':
    'Report processing time varies depending on the number of records being retrieved.',
  'customReporting.printModalHeadline':
    'Your print selection includes a high number of transactions and may cause your session to time out.',
  'customReporting.printModalText':
    'Continue to proceed with print. Cancel to modify your selection criteria or to export the report, which requires less time.',
  'customReporting.reportOptions': 'Report Options',
  'customReporting.report': 'Report',
  'customReporting.manageReport': 'Manage Reports',
  'customReporting.newReport': 'New Report',
  'customReporting.saveReport': 'Save report',
  'customReporting.newReportName': 'New Report Name',
  'customReporting.savedReportMessage': 'Changes to this report will not be saved.',
  'customReporting.USER_NOT_PERMITTED_TO_DELETE_REPORT_CRITERIA':
    'User is not permitted to delete report criteria',
  'customReporting.unableToDelete': 'The following reports could not be deleted',
  'customReporting.shareReport': 'Make available to others (report must be saved)',
  'customReporting.shareReportTooltip': 'Shared reports can only be managed by the owner',
  'customReporting.shareReportColumn': 'Shared',
  'customReporting.reportSaved': 'Report saved.',
  'customReporting.shareReportIsShared': '"<%= reportName %>" is set to shared.',
  'customReporting.shareReportIsNotShared': '"<%= reportName %>" is set to private.',
  'customReporting.manageMySavedReports': 'Manage My Saved Reports',
  'customReporting.accountReport': 'Account Report',
  'customReporting.logo': 'Logo',
  'customReporting.savedReports': 'Saved Reports',

  // balance labels
  'customReporting.openingLedger': 'Opening Ledger',
  'customReporting.closingLedger': 'Closing Ledger',
  'customReporting.openingAvailable': 'Opening Available',
  'customReporting.totalFloat': 'Total Float',

  'customReporting.availableLoanCommitment': 'Available Commitment Amount',
  'customReporting.loanBalance': 'Principal Balance',

  // print
  'customReporting.reportGenerated': 'Report Generated'
};
